<template>
    <div :class=classes>
        <slot name="label"></slot>
        <transition name="slide-fade">
            <div
                    class="d-flex pa-3 mt-2 upload-area flex-column"
                    @drop.prevent="onDrop($event)"
                    @dragover.prevent="dragover = true"
                    @dragenter.prevent="dragover = true"
                    @dragleave.prevent="dragover = false"
                    :class="{ 'dragover primary--text': dragover }"
            >
                <input type="file" :accept=accept style="display: none" ref="fileInput" v-on:change="handleFileUpload($event)"/>

                <div class="text-center" v-if="!value">
                    <v-icon size="60">
                        mdi-cloud-upload-outline
                    </v-icon>
                    <p>فایل خود را بکشید و در اینجا رها کنید و یا برای انتخاب روی لینک زیر کلیک کنید</p>
                    <v-btn
                            small
                            elevation="2"
                            @click="$refs.fileInput.click()"
                    >
                        انتخاب فایل
                    </v-btn>
                </div>
                <div class="text-center" v-if="value">
                    <v-icon size="60">
                        mdi-file-pdf-outline
                    </v-icon>
                    <div>{{value.name}}</div>
                    <div>Size :
                        <span v-if="kbSize < 999">{{kbSize}} KB</span>
                        <span v-else>{{mbSize}} MB</span>
                    </div>
                    <v-btn
                            small
                            text
                            @click="value = null"
                    >
                        حذف فایل
                    </v-btn>
                    <v-btn
                            small
                            elevation="2"
                            @click="$refs.fileInput.click()"
                    >
                        تغییر فایل
                    </v-btn>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: true
            },
            rules: {
                default: []
            },
            accept: {
                default: null
            },
            classes: {
                default: null
            },
        },
        computed : {
            kbSize(){
                let size = this.value.size || 0;
                return parseInt(size / 1000)
            },
            mbSize(){
                let size = this.value.size || 0;
                return parseInt(size / 1000000)
            },
        },
        data(){
            return {
                dragover : false

            }
        },
        created(){
        },
        methods: {
            setValue(files){
                let file = files[0];
                let errorMessages = this.validate(file);
                if(errorMessages.length <= 0){
                    return this.$emit("input", file );
                }else{
                    this.showErrors(errorMessages);
                }
            },
            onDrop(e) {
                this.dragover = false;
                if (e.dataTransfer.files.length > 1) {
                    // TODO: handle multiple files
                } else{
                    this.setValue(e.dataTransfer.files);
                }
            },
            validate(file){
                let errorMessages = [];
                this.rules.forEach(rule => {
                   let errorMessage = rule(file);
                   if(errorMessage !== true){
                       errorMessages.push(errorMessage);
                   }
                });
                return errorMessages;
            },
            showErrors(errorMessages){
                errorMessages.forEach(errorMessage => {
                    this.$notify({
                        group: 'formGroup',
                        type: 'error',
                        text: errorMessage
                    });
                });
            },
            handleFileUpload(e){
                this.setValue(e.target.files);
            }

        }
    }
</script>

<style type="text/css" scoped>
    .upload-area{
        border: 4px dashed;
    }
</style>